import { makeAutoObservable, runInAction } from 'mobx'
import { logger } from 'shared/lib'

type iGoogleReCaptchaLayoutStoreConfig = {
  executeRecaptcha: ((action?: string) => Promise<string>) | null
}

export class ReCaptchaV3Store {
  private _token = ''
  private _executeRecaptcha: iGoogleReCaptchaLayoutStoreConfig['executeRecaptcha'] | null = null

  constructor() {
    makeAutoObservable(this)
  }

  get token() {
    return this._token
  }

  initToken = async (action: string): Promise<string> => {
    return new Promise((resolve) => {
      if (!this._executeRecaptcha) {
        return resolve('')
      }

      this._executeRecaptcha(action)
        .then((token) => {
          runInAction(() => {
            this._token = token

            resolve(this._token)
          })
        })
        .catch((e) => {
          logger.error(e)

          runInAction(() => {
            this._token = ''

            resolve('')
          })
        })
    })
  }

  setConfig = (config: iGoogleReCaptchaLayoutStoreConfig) => {
    this._executeRecaptcha = config.executeRecaptcha
  }
}
